"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreOptionsDefault = void 0;
const helpers_1 = require("../helpers");
// TODO unused for now
exports.coreOptionsDefault = {
    logLevel: helpers_1.LogLevels.Warn,
};
//# sourceMappingURL=options.js.map